import { Link } from "react-router-dom";
import { Home, Search, Phone } from "lucide-react";
import Seo from "../components/Seo";
import { Container, Cta, Eyebrow } from "../components/ui-kit";
import { CATEGORIES, CONTACT } from "../mock";

const NotFound = () => (
  <main className="bg-canvas min-h-[70vh] flex items-center" data-testid="notfound-page">
    <Seo
      title="Sayfa Bulunamadı (404) — Koşan Düğme"
      description="Aradığınız sayfa taşınmış veya kaldırılmış olabilir. Ürünlerimize göz atın ya da bizimle iletişime geçin."
      path="/404"
      noindex
    />
    <Container className="py-20 lg:py-28 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7">
        <Eyebrow>Hata 404</Eyebrow>
        <h1 className="font-display font-light text-6xl sm:text-7xl lg:text-8xl leading-none text-ink mt-5">
          40<span className="text-brand">4</span>
        </h1>
        <h2 className="font-display font-light text-2xl sm:text-3xl text-ink mt-6">
          Aradığınız sayfayı bulamadık.
        </h2>
        <p className="text-ink2 leading-relaxed mt-4 max-w-md">
          Sayfa taşınmış, adı değişmiş ya da kaldırılmış olabilir. Aşağıdaki bağlantılardan devam edebilir veya bize
          ulaşabilirsiniz.
        </p>
        <div className="flex flex-wrap items-center gap-4 mt-9">
          <Cta to="/" data-testid="notfound-home-cta">
            <Home size={16} /> Anasayfaya dön
          </Cta>
          <Cta to="/urunler" variant="ghost" data-testid="notfound-products-cta">
            <Search size={16} /> Ürünleri incele
          </Cta>
          <a
            href={CONTACT.phoneHref}
            className="inline-flex items-center gap-2 text-[13px] font-semibold text-ink hover:text-brand transition-colors"
            data-testid="notfound-phone"
          >
            <Phone size={15} className="text-brand" /> {CONTACT.phone}
          </a>
        </div>
      </div>
      <div className="lg:col-span-5">
        <div className="bg-paper border border-line p-7">
          <p className="text-[11px] font-semibold tracking-[0.25em] uppercase text-mute mb-5">Popüler Ürün Grupları</p>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-3.5">
            {CATEGORIES.slice(0, 8).map((c) => (
              <li key={c.id}>
                <Link
                  to={`/urunler?kategori=${c.id}`}
                  className="text-[13px] text-ink hover:text-brand transition-colors"
                  data-testid={`notfound-cat-${c.id}`}
                >
                  {c.name.charAt(0) + c.name.slice(1).toLocaleLowerCase("tr")}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Container>
  </main>
);

export default NotFound;
